import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

const CONSENT_KEY = "hwhc_cookie_consent";

export const hasAnalyticsConsent = () => localStorage.getItem(CONSENT_KEY) === "accepted";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-card p-4 shadow-lg sm:bottom-4 sm:left-4 sm:right-auto sm:max-w-sm sm:rounded-xl sm:border">
      <div className="flex items-start gap-3">
        <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-accent" />
        <div className="space-y-3">
          <p className="text-sm text-foreground/80">
            We use cookies to improve your experience. By clicking Accept, you agree to our use of analytics cookies.{" "}
            <Link to="/privacy-policy" className="font-medium text-accent underline underline-offset-2 hover:text-accent/80">
              Privacy Policy
            </Link>
          </p>
          <div className="flex gap-2">
            <Button size="sm" onClick={handleAccept} className="rounded-full bg-accent text-accent-foreground hover:bg-accent/90">
              Accept
            </Button>
            <Button size="sm" onClick={handleDecline} className="rounded-full bg-accent text-accent-foreground hover:bg-accent/90">
              Decline
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
